import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import WhatWeDo from "@/components/WhatWeDo";
import Thesis from "@/components/Thesis";
import Collaboration from "@/components/Collaboration";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";

export default function LandingPage() {
    return (
        <div className="relative min-h-screen bg-[#0D0D1A] text-[#E8E6DF] grain">
            <Navigation />
            <main className="relative z-10">
                <Hero />
                <WhatWeDo />
                <Thesis />
                <Collaboration />
                <ContactForm />
            </main>
            <Footer />
        </div>
    );
}
